module.exports = __webpack_public_path__ + "static/media/w (25).561c2c44.jpg";